import { render, staticRenderFns } from "./FormLiberacoes.vue?vue&type=template&id=e0ec0488&scoped=true"
import script from "./FormLiberacoes.vue?vue&type=script&lang=js"
export * from "./FormLiberacoes.vue?vue&type=script&lang=js"
import style0 from "./FormLiberacoes.vue?vue&type=style&index=0&id=e0ec0488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ec0488",
  null
  
)

export default component.exports